import { useQuery } from '@tanstack/react-query';
import Global from '../../../../../Services/Common/Global';
import { apiRequest } from '../../../../../Services/Common/ApiRequest';
import { mapParamsBySchema } from '../../../../../util';
import useSaveMutation from '../../../../../hooks/apis/useSaveMutaion';
import { Improvement_Schema } from './Improvement_Schema';

/**
 * 개선보고서 — 위험성평가 실시와 동일 조회 GetRisCustom02R1
 * (표시 행 필터는 Improvement_Schema.BuildImprovementReportRows)
 */
export const useSearch1 = (options = {}) => {
  const { rsCd, searchText = '', enabled = true } = options;
  return useQuery({
    queryKey: [
      'RiskEvaluation',
      'Improvement',
      'getRisCustom02R1',
      rsCd,
      searchText,
    ],
    enabled: enabled !== false && Number(rsCd) > 0,
    queryFn: async () => {
      const params = mapParamsBySchema(Improvement_Schema.mapper.search1, {
        rsCd,
        searchText,
      });
      return apiRequest(
        'post',
        Global.urls.RiskEvaluation.getRisCustom02R1,
        params
      );
    },
  });
};

/**
 * SaveRisCustom03U1 — TB_SF_RISK_PROGRESS 단계 갱신
 * @param context — { rsCd, stepSeq? }
 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(
    async (context) => {
      const payload = mapParamsBySchema(
        Improvement_Schema.mapper.save1,
        context ?? {}
      );
      return apiRequest(
        'post1',
        Global.urls.RiskEvaluation.saveRisCustom03U1,
        payload
      );
    },
    options,
    false
  );
};
